import { CHAT_WIDGET_VERSION } from "../../../types/enum/enum";

export const CHATROOM_OPTIONS = [
    { value: CHAT_WIDGET_VERSION.MESSENGER, label: "Messenger" },
    { value: CHAT_WIDGET_VERSION.AVATAR, label: "Avatar" },
    { value: CHAT_WIDGET_VERSION.MOBILE, label: "Mobile" },
];
